export default "__VITE_ASSET__CfiGXAiF__"